import React from "react";

interface TextBubbleProps {
  label?: string;
  iconClass?: string;
}

const TextBubble: React.FC<TextBubbleProps> = (props: TextBubbleProps): JSX.Element => {
  const { iconClass = "", label = "" } = props;

  return (
    <div className="text-bubble-wrapper">
      <div className="text-bubble text-bubble-dimension">
        <span className={`text-bubble-icon ${iconClass}`}>
          <span className="bubble-text">{label}</span>
        </span>
      </div>
    </div>
  );
};

export default TextBubble;
